module.exports = __webpack_public_path__ + "static/media/gotgift.f0c6f16e.png";